import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import PageLayout from '../components/PageLayout';
import Button from '../components/ui/Button';
import { MvLandscape } from '../components/brand/MvLandscape';

function NotFound({
  eyebrow,
  title,
  description,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const resolvedEyebrow =
    eyebrow ?? t('notFound.eyebrow');

  const resolvedTitle =
    title ?? t('notFound.title');

  const resolvedDescription =
    description ?? t('notFound.description');

  function handleGoBack() {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }

    navigate('/');
  }

  return (
    <PageLayout>
      <main className="main error-main">
        <section
          className="error-card"
          aria-labelledby="error-title"
        >
          <div className="error-copy">
            <p className="error-eyebrow">
              {resolvedEyebrow}
            </p>

            <p
              className="error-code"
              aria-hidden="true"
            >
              404
            </p>

            <h1 id="error-title">
              {resolvedTitle}
            </h1>

            <p>
              {resolvedDescription}
            </p>

            <div className="error-actions">
              <Button
                variant="error"
                className="primary"
                to="/"
              >
                <i className="fa-solid fa-house" />
                {t('notFound.backToMenu')}
              </Button>

              <Button
                variant="error"
                onClick={handleGoBack}
              >
                <i className="fa-solid fa-arrow-left" />
                {t('notFound.previousPage')}
              </Button>
            </div>
          </div>

          <div
            className="error-visual"
            aria-hidden="true"
          >
            <MvLandscape
              className="error-landscape"
              bands={[
                { color: 'var(--mv-himmelblau)', top: 48, amplitude: 26 },
                { color: 'var(--mv-wiesengruen)', top: 70, amplitude: 20, flip: true },
              ]}
            />
            <i className="fa-solid fa-map-location-dot" />
          </div>
        </section>
      </main>
    </PageLayout>
  );
}

export default NotFound;
